import React from 'react';

const TermsAndConditions = () => {
    return (
        <>
            <h2 className="policy-title">Terms & Conditions – Blossom & Bond</h2>
            <p>Welcome to Blossom & Bond. By booking a class with us in our The Hague sanctuary, you agree to the following:</p>

            <h3 className="policy-subtitle">1. Bookings & Payments</h3>
            <p>All spots are reserved on a first-come, first-served basis through our website. Payment must be completed to secure your place in the class.</p>

            <h3 className="policy-subtitle">2. Cancellation Policy</h3>
            <p>We understand that life with a baby can be unpredictable. Cancellations made more than 48 hours before the class will be eligible for a refund/credit. Unfortunately, we cannot offer refunds for late cancellations.</p>

            <h3 className="policy-subtitle">3. Health & Safety</h3>
            <p>Parents/guardians are responsible for their children at all times during the sessions. Please inform us of any allergies or special requirements before the class starts.</p>

            <h3 className="policy-subtitle">4. Photography</h3>
            <p>We love capturing beautiful moments. We will always ask for your explicit consent before taking or sharing any photos where you or your baby are identifiable.</p>
        </>
    );
};

export default TermsAndConditions;
